import React, { useEffect, useRef, useState, Suspense } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import Login from './views/Login';
import LoginCallback from './LoginCallback';
import { useEnv } from './providers/EnvContext';
import { useGetUserInfo } from './services/userApi';
import { removeOrigUrl, storeOrigUrl } from './utils/storeOrigUrl';
import KoneLoader from './components/KoneLoader';
import { trackUserEvent } from './services/analyticsEventService';
import Reset from './components/Reset';
import UserAdmin from './views/UserAdmin';
import { initPdfWorker } from './utils/pdfWorkerFactory';

if (process.env.NODE_ENV !== 'test') {
  initPdfWorker();
}

const Chat = React.lazy(() => import('./views/Chat'));

const AppRouting = () => {
    const navigate = useNavigate();
    const {
        isAuthenticated,
        setIsAuthenticated,
        setUsername,
        setUid,
        setCompanyCode,
        setUserRole,
        userRole
    } = useEnv();
    const [isUserInitReady, setIsUserInitReady] = useState(false);
    const [hideCoreLoader, setHideCoreLoader] = useState(false);
    const initialRedirectRef = useRef(false);
    const userInfoRef = useRef(false);

  const getUserInfo = useGetUserInfo();

    const getUserInfoAndInit = async () => {
        if (userInfoRef.current) return;
        userInfoRef.current = true;
        const userInfo = await getUserInfo();
        setUsername(userInfo.user || '');
        setUid(userInfo.uid || '');
        setCompanyCode(userInfo.company_code || '');
        setUserRole(userInfo.role || '');
        setIsUserInitReady(true);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      user_role: 'generic' // DEVNOTE: update to comply with new AD role
    })

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            user_role: userRole
        })

  const loadSurvicate = () => {
    const workspaceId = localStorage.getItem('tai_survicateWorkspace');
    if (!workspaceId) return;

    const script = document.createElement('script');
    script.innerHTML = `
        (function (w) {
          var s = document.createElement('script');
          s.src = '//survey.survicate.com/workspaces/${workspaceId}/web_surveys.js';
          s.async = true;
          var e = document.getElementsByTagName('script')[0];
          e.parentNode.insertBefore(s, e);
        })(window._sva = window._sva || {});
      `;
    document.body.appendChild(script);
  }

  useEffect(() => {
    if (isUserInitReady) {
      setHideCoreLoader(true);
      // loadGoogleTagManager();
      loadSurvicate();
      // if arrived via old session
      if (!isAuthenticated) setIsAuthenticated(true);
    }
  }, [isUserInitReady]); // eslint-disable-line

  useEffect(() => {
    if (!isAuthenticated) storeOrigUrl();
    const isSessionFresh = (window.shellJsBridgeWebToNative || window.androidJsBridge) ? true :
      Date.now() <
      parseInt(localStorage.getItem('refreshSessionAfter') || '0');
    if ((isSessionFresh || isAuthenticated) && !isUserInitReady) {
      getUserInfoAndInit();
    } else if (!isAuthenticated) {
      // login
      setHideCoreLoader(true);
    }
  }, [isAuthenticated]); // eslint-disable-line

  useEffect(() => {
    const trackEventHandler = (event) => {
      const trackElement = event.target.closest('[data-te="true"]'); // track event

      if (trackElement) {
        const category = trackElement.getAttribute('data-tc'); // track category
        const action = trackElement.getAttribute('data-ta'); // track action
        trackUserEvent({ category, action });
      }
    };

    document.addEventListener('click', trackEventHandler);

    return () => {
      document.removeEventListener('click', trackEventHandler);
    };
  }, []);

  if (!hideCoreLoader) {
    return <div><KoneLoader /></div>;
  }

  const getRedirectRoute = () => {
    const origUrl = localStorage.getItem('origUrl');
    if (origUrl) {
      removeOrigUrl();
      return origUrl;
    } else {
      return '/chat';
    }
  }

  const LoginCallbackRouting = ({ isAuthenticated }) => {
    const navigate = useNavigate();

    useEffect(() => {
      if (isAuthenticated) {
        if (initialRedirectRef.current) return;
        initialRedirectRef.current = true;
        const redirectUrl = getRedirectRoute();
        navigate(redirectUrl);
      }
    }, [isAuthenticated, navigate]);

    return <LoginCallback />;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/reset"
        element={<Reset />}
      />
      <Route
        path="/chat/:cid?"
        element={
          (isAuthenticated || window.shellJsBridgeWebToNative || window.androidJsBridge) ? (
            <Suspense fallback={<div><KoneLoader /></div>}>
              <Chat />
            </Suspense>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route path="/admin/users"
        element={
          isAuthenticated ? (
            <Suspense fallback={<div><KoneLoader /></div>}>
              <UserAdmin />
            </Suspense>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route path="*"
        element={(isAuthenticated || window.shellJsBridgeWebToNative || window.androidJsBridge) ? <Navigate to="/chat" /> : <Navigate to="/login" />}
      />
      <Route path="/login-callback" element={<LoginCallbackRouting isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default AppRouting;
